import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment-timezone';

const userTimeZone = moment.tz.guess();

const initialState = {
    updateListStore: '',
    updateListStoreStar: '',
    updateListStoreTrash: '',
    // store: null,
    currentStore: sessionStorage.getItem('currentStore') ? JSON.parse(sessionStorage.getItem('currentStore')) : null,
    currentStoreCustomer: sessionStorage.getItem('currentStoreCustomer')
        ? JSON.parse(sessionStorage.getItem('currentStoreCustomer'))
        : null,

    listOrder: [],
    total: 0,
    filter: {
        minPrice: null,
        maxPrice: null,
        orderStatus: null,
        startTime: moment.tz(userTimeZone).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment.tz(userTimeZone).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    },
    listShopForm: [],
};

export const storeSlice = createSlice({
    name: 'store',
    initialState,
    reducers: {
        setUpdateListStore: (state, action) => {
            state.updateListStore = action.payload;
        },

        setUpdateListStoreStar: (state, action) => {
            state.updateListStoreStar = action.payload;
        },

        setUpdateListStoreTrash: (state, action) => {
            state.updateListStoreTrash = action.payload;
        },

        setCurrentStore: (state, action) => {
            state.currentStore = action.payload;
            // sessionStorage.setItem('currentStore', action.payload);
            sessionStorage.setItem('currentStore', JSON.stringify(action.payload));
            // sessionStorage.setItem('currentStore', JSON.stringify(state));
        },

        setCurrentStoreCustomer: (state, action) => {
            state.currentStoreCustomer = action.payload;
            sessionStorage.setItem('currentStoreCustomer', JSON.stringify(action.payload));
        },

        setListOrder: (state, action) => {
            state.listOrder = action.payload;
        },

        setTotal: (state, action) => {
            state.total = action.payload;
        },

        setFilter: (state, action) => {
            state.filter = action.payload;
        },

        setListShopForm: (state, action) => {
            console.log('setListShopForm action.payload', action.payload);
            state.listShopForm = action.payload;
        },
    },
});

export const {
    setUpdateListStore,
    setUpdateListStoreStar,
    setUpdateListStoreTrash,
    setCurrentStore,
    setCurrentStoreCustomer,
    setListOrder,
    setTotal,
    setFilter,
    setListShopForm,
} = storeSlice.actions;

export default storeSlice.reducer;
